(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blz-d200-platform"] && !Shopify.designMode) return;
  try {
    

(function(){
  const tag = 'blz-uhp-story-v2';

  if(customElements.get(tag)){
    return;
  }

  class BlzUhpStoryV2 extends HTMLElement{

    connectedCallback(){

      this.terminal =
        this.querySelector(
          '[data-terminal]'
        );

      this.tabsContainer =
        this.querySelector(
          '[data-tabs-container]'
        );

      this.tabs =
        Array.from(
          this.querySelectorAll(
            '[data-tab]'
          )
        );

      this.images =
        Array.from(
          this.querySelectorAll(
            '.blz-uhp-terminal__image-shell[data-image-key]'
          )
        );

      this.metric =
        this.querySelector(
          '[data-metric]'
        );

      this.metricLabel =
        this.querySelector(
          '[data-metric-label]'
        );

      this.readoutTitle =
        this.querySelector(
          '[data-readout-title]'
        );

      this.readoutDetail =
        this.querySelector(
          '[data-readout-detail]'
        );

      this.indexLabel =
        this.querySelector(
          '[data-index]'
        );

      this.current = 0;
      this.timer = null;

      this.autoCycle =
        this.dataset.autoCycle === 'true';

      this.cycleTime =
        Number(
          this.dataset.cycleTime || 7000
        );

      this.reduceMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

      this.desktop =
        window.matchMedia(
          '(min-width: 750px)'
        );

      this.tabs.forEach(
        (tab,index)=>{

          tab.addEventListener(
            'click',
            ()=>{
              this.activate(
                index,
                true
              );
            }
          );

          tab.addEventListener(
            'keydown',
            event=>{

              if(
                event.key !== 'ArrowLeft'
                &&
                event.key !== 'ArrowRight'
              ){
                return;
              }

              event.preventDefault();

              let nextIndex = index;

              if(
                event.key === 'ArrowRight'
              ){

                nextIndex =
                  (
                    index + 1
                  )
                  %
                  this.tabs.length;

              }else{

                nextIndex =
                  (
                    index
                    -
                    1
                    +
                    this.tabs.length
                  )
                  %
                  this.tabs.length;

              }

              this.activate(
                nextIndex,
                true
              );

              this.tabs[
                nextIndex
              ].focus();

            }
          );

        }
      );

      if(this.terminal){

        this.terminal.addEventListener(
          'pointermove',
          event=>this.tilt(event)
        );

        this.terminal.addEventListener(
          'pointerleave',
          ()=>this.resetTilt()
        );

      }

      if(this.tabs.length){

        this.activate(
          0,
          false
        );

        this.start();

      }

    }

    disconnectedCallback(){

      this.stop();

    }

    activate(
      index,
      restart
    ){

      if(!this.tabs.length){
        return;
      }

      this.current =
        index %
        this.tabs.length;

      const tab =
        this.tabs[
          this.current
        ];

      this.tabs.forEach(
        (item,itemIndex)=>{

          const active =
            itemIndex ===
            this.current;

          item.classList.toggle(
            'is-active',
            active
          );

          item.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );

        }
      );

      if(this.metric){

        this.metric.textContent =
          tab.dataset.metric || '';

      }

      if(this.metricLabel){

        this.metricLabel.textContent =
          tab.dataset.metricLabel || '';

      }

      if(this.readoutTitle){

        this.readoutTitle.textContent =
          tab.dataset.readoutTitle || '';

      }

      if(this.readoutDetail){

        this.readoutDetail.textContent =
          tab.dataset.readoutDetail || '';

      }

      if(this.indexLabel){

        this.indexLabel.textContent =
          String(
            this.current + 1
          ).padStart(
            2,
            '0'
          )
          +
          ' / '
          +
          String(
            this.tabs.length
          ).padStart(
            2,
            '0'
          );

      }

      const imageKey =
        tab.dataset.imageKey
        ||
        'overview';

      this.images.forEach(
        image=>{

          image.classList.toggle(
            'is-active',
            image.dataset.imageKey ===
            imageKey
          );

        }
      );

      this.centerActiveTab(
        tab
      );

      if(restart){

        this.stop();
        this.start();

      }else{

        this.restartProgress();

      }

    }

    centerActiveTab(tab){

      if(
        !this.tabsContainer
        ||
        window.innerWidth >= 750
      ){
        return;
      }

      const left =
        tab.offsetLeft
        -
        (
          this.tabsContainer.clientWidth
          -
          tab.clientWidth
        )
        /
        2;

      this.tabsContainer.scrollTo({
        left:Math.max(
          0,
          left
        ),
        behavior:
          this.reduceMotion.matches
            ? 'auto'
            : 'smooth'
      });

    }

    restartProgress(){

      this.classList.remove(
        'is-cycling'
      );

      void this.offsetWidth;

      if(this.autoCycle){

        this.classList.add(
          'is-cycling'
        );

      }

    }

    start(){

      this.stop();

      if(
        !this.autoCycle
        ||
        this.tabs.length < 2
      ){
        return;
      }

      this.restartProgress();

      this.timer =
        window.setInterval(
          ()=>{

            this.activate(
              (
                this.current + 1
              )
              %
              this.tabs.length,
              false
            );

          },
          this.cycleTime
        );

    }

    stop(){

      if(this.timer){

        window.clearInterval(
          this.timer
        );

        this.timer = null;

      }

      this.classList.remove(
        'is-cycling'
      );

    }

    tilt(event){

      if(
        !this.terminal
        ||
        !this.desktop.matches
        ||
        this.reduceMotion.matches
      ){
        return;
      }

      const rect =
        this.terminal
          .getBoundingClientRect();

      const x =
        (
          event.clientX
          -
          rect.left
        )
        /
        rect.width
        -
        .5;

      const y =
        (
          event.clientY
          -
          rect.top
        )
        /
        rect.height
        -
        .5;

      this.terminal.style.setProperty(
        '--blz-tilt-y',
        (
          x * 1.8
        )
        +
        'deg'
      );

      this.terminal.style.setProperty(
        '--blz-tilt-x',
        (
          y * -1.3
        )
        +
        'deg'
      );

    }

    resetTilt(){

      if(!this.terminal){
        return;
      }

      this.terminal.style.setProperty(
        '--blz-tilt-y',
        '0deg'
      );

      this.terminal.style.setProperty(
        '--blz-tilt-x',
        '0deg'
      );

    }

  }

  customElements.define(
    tag,
    BlzUhpStoryV2
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {


  constructor() {

    super();

  }


  connectedCallback() {


    this.header =
      document.querySelector(
        '.section-header'
      );


    this.headerIsAlwaysSticky =

      this.getAttribute(
        'data-sticky-type'
      ) === 'always' ||

      this.getAttribute(
        'data-sticky-type'
      ) === 'reduce-logo-size';


    this.headerBounds =
      {};


    this.setHeaderHeight();


    window
      .matchMedia(
        '(max-width: 990px)'
      )
      .addEventListener(
        'change',
        this.setHeaderHeight.bind(this)
      );


    if (
      this.headerIsAlwaysSticky
    ) {


      this.header.classList.add(
        'shopify-section-header-sticky'
      );


    }


    this.currentScrollTop =
      0;


    this.preventReveal =
      false;


    this.predictiveSearch =
      this.querySelector(
        'predictive-search'
      );


    this.onScrollHandler =
      this.onScroll.bind(this);


    this.hideHeaderOnScrollUp =
      () =>
        (
          this.preventReveal = true
        );


    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );


    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );


    this.createObserver();


  }


  setHeaderHeight() {


    if (!this.header) return;


    document
      .documentElement
      .style
      .setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );


  }


  disconnectedCallback() {


    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );


    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );


  }


  createObserver() {


    let observer =
      new IntersectionObserver(
        (entries) => {


          this.headerBounds =
            entries[0]
              .intersectionRect;


          observer.disconnect();


        }
      );


    observer.observe(
      this.header
    );


  }


  onScroll() {


    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;


    if (
      this.predictiveSearch &&
      this.predictiveSearch.isOpen
    ) return;


    if (

      scrollTop >
        this.currentScrollTop &&

      scrollTop >
        this.headerBounds.bottom

    ) {


      this.header.classList.add(
        'scrolled-past-header'
      );


      if (
        this.preventHide
      ) return;


      requestAnimationFrame(
        this.hide.bind(this)
      );


    } else if (

      scrollTop <
        this.currentScrollTop &&

      scrollTop >
        this.headerBounds.bottom

    ) {


      this.header.classList.add(
        'scrolled-past-header'
      );


      if (
        !this.preventReveal
      ) {


        requestAnimationFrame(
          this.reveal.bind(this)
        );


      } else {


        window.clearTimeout(
          this.isScrolling
        );


        this.isScrolling =
          setTimeout(
            () => {

              this.preventReveal =
                false;

            },
            66
          );


        requestAnimationFrame(
          this.hide.bind(this)
        );


      }


    } else if (

      scrollTop <=
        this.headerBounds.top

    ) {


      this.header.classList.remove(
        'scrolled-past-header'
      );


      requestAnimationFrame(
        this.reset.bind(this)
      );


    }


    this.currentScrollTop =
      scrollTop;


  }


  hide() {


    if (
      this.headerIsAlwaysSticky
    ) return;


    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );


    this.closeMenuDisclosure();


    this.closeSearchModal();


  }


  reveal() {


    if (
      this.headerIsAlwaysSticky
    ) return;


    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );


    this.header.classList.remove(
      'shopify-section-header-hidden'
    );


  }


  reset() {


    if (
      this.headerIsAlwaysSticky
    ) return;


    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );


  }


  closeMenuDisclosure() {


    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll(
        'header-menu'
      );


    this.disclosures.forEach(
      (disclosure) => {


        if (
          typeof disclosure.close ===
          'function'
        ) {

          disclosure.close();

        }


      }
    );


    this
      .querySelectorAll(
        '.blz-header__details[open]'
      )
      .forEach(
        (menu) => {


          menu.removeAttribute(
            'open'
          );


        }
      );


  }


  closeSearchModal() {


    this.searchModal =
      this.searchModal ||
      this.querySelector(
        'details-modal'
      );


    if (
      this.searchModal &&
      typeof this.searchModal.close ===
        'function'
    ) {


      this.searchModal.close(
        false
      );


    }


  }


}


if (
  !customElements.get(
    'sticky-header'
  )
) {


  customElements.define(
    'sticky-header',
    StickyHeader
  );


}


  } catch(e) { console.error(e); }
})();
})();
